// src/pages/Blog.jsx
const Blog = () => 
<div></div>

export default Blog;